// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"78b8357e","612":"403d3398","808":"5ebad92b"}[chunkId] + ".chunk.js";
};